export default {
    headers: [
        {
            text: "Pack Type",
            align: "left",
            sortable: true,
            value: "planMaster.planType"
        },
        {
            text: "Pack Name",
            value: "planMaster.planName"
        },
        {
            text: "Total Channels ",
            value: "planMaster.channelCount"
        },
        {
            text: "Price",
            value: "finalPrice"
        },
        {
            text: "Expires on",
            value: "end_DATE"
        }
      ],
      packColumns: [
        {
            text: "Name",
            value: "planName"
        },
        {
            text: "Channels",
            value: "channelCount"
        },
        {
            text: "Price per month",
            value: "finalPrice"
        }
    ]
}